import React, { useEffect, useState } from 'react';
import { api } from '../../api'; // Adjust path if needed

const DeviceList = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const payload = {
    ID: 'AllDevices',
    IsTag: false,
    SortColumn: 'LastTimeStamp',
    SortOrder: 'desc',
    Limit: 10,
    Offset: 0,
    IsSearch: true,
    IsIncludedBlackListed: true,
    AdanceSearch: false,
    EnableDeviceGlobalSearch: true,
    SearchValue: '%',
  };

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        const response = await api.post('/mdm/devices', payload); // Updated to POST with payload
        const data = response.data;
        setDevices(data.devices || data.data || data); // Adjust to your API's structure
      } catch (err) {
        console.error('Error fetching devices:', err);
        setError(err.message || 'Error fetching devices');
      } finally {
        setLoading(false);
      }
    };

    fetchDevices();
  }, []);

  if (loading) return <p>Loading devices...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <h2>Enrolled Devices</h2>
      <ul>
        {devices.map((device, idx) => (
          <li key={idx}>
            {device.DeviceName || device.DeviceID || `Device ${idx + 1}`}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeviceList;
